import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { currentUserPersonQuery } from '../api'
import { authSelector } from '../reducers/index.js'

interface Auth {
	employeeNumber: string
}

export const useCurrentUser = () => {
	const auth: Auth | null = useSelector(authSelector)
	return useQuery(currentUserPersonQuery(auth?.employeeNumber)).data
}
